









































import {
  apiPageConfigDecorateGetData,
  apiPageConfigDecorateGetStyle,
} from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '商品列表',
        }))
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        componentId: string
      }>()

      apiData = useApiPlus({
        componentData: () =>
          apiPageConfigDecorateGetStyle({
            id: this.query.componentId,
          }),
      })

      componentData = computed(() => this.apiData.data.componentData)

      isArticleStyle = computed(
        () => this.componentData.value.type === 'ARTICLE_ITEM',
      )

      pageTitle = computed(() =>
        this.isArticleStyle.value ? '文章列表' : '商品列表',
      )

      showHeadImage = computed(
        () => this.componentData.value.type === 'MARKETING_SCENE',
      )

      headImage = computed(
        () =>
          // @ts-ignore
          this.componentData.value.style.jumpPageHeadImage,
      )

      showFilter = computed(
        () => !this.isArticleStyle.value && !this.showHeadImage.value,
      )

      handleDataLoad = (payload: any) =>
        apiPageConfigDecorateGetData({
          ...payload,
          id: this.query.componentId,
        })
    },
)
